<ng-container *ngIf="isLoaded; else loaderBlock">
  <div
    class="landing"
    *transloco="let t">
    <div
      class="landing_hero __full-screen"
      appBackgroundBranded>
      <div class="landing_hero_main">
        <form
          class="fb-panel"
          [formGroup]="findCompanyForm"
          (ngSubmit)="findCompany()">
          <ic-logo class="fb-panel_logo"></ic-logo>

          <!-- Title -->
          <h2 class="fb-panel_title">{{ t('auth.find-company.title') }}</h2>

          <!-- Email -->
          <div class="fb-panel_row form-control-labelled">
            <input
              type="email"
              class="form-control"
              [ngClass]="{ 'ng-not-empty': emailControl.value.length }"
              autocomplete="off"
              autofocus
              id="loginEmail"
              name="email"
              formControlName="email" />
            <label
              class="form-control-labelled_label__no-star"
              for="loginEmail"
              >{{ t('common.email') }}</label
            >

            <div
              class="message __error"
              role="alert"
              *ngIf="emailControl.invalid && emailControl.dirty">
              <ng-container *ngIf="emailControl.errors?.required">{{ t('common.enter-email') }}</ng-container>
              <ng-container *ngIf="emailControl.errors?.fbInvalidEmail">{{
                t('common.enter-valid-email')
              }}</ng-container>
            </div>
          </div>

          <re-captcha *ngIf="recaptchaService.isEnabled"></re-captcha>

          <!-- Submit button -->
          <button
            type="submit"
            class="btn __l __block"
            [disabled]="isInProgress"
            ngPreserveWhitespaces>
            <i
              class="spinner"
              *ngIf="isInProgress"></i>
            {{ t('auth.find-company.submit') }}
          </button>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loaderBlock>
  <app-icon
    class="layout_spinner"
    name="spinner"></app-icon>
</ng-template>
